<div class="container-fluid main-card">
    <div class="row">
        <div class="col-sm-8 col-11">
            <h1>
                {{ (this.currentSearch && params.id != 'result' ? 'Votre secteur ' + this.currentSearch.title : 'Secteur de recherche') }}
                <span>Trouvez les meilleures villes où investir</span>
            </h1>
        </div>
        <div class="col-sm-4 col-1">
            <p class="btn btn-outline float-right  mobile-icon mt-4" (click)="openTuto()">
                <img src="assets/icons/yt.png"  class="n-size"alt=""/><span>Tutoriel : Mes secteurs</span>
            </p>
        </div>
    </div>
    <div class="row mb-2 mb-sm-4">
        <div class="col-lg-4 col-8 pe-0">
            <mat-form-field class="no-label" [stepContent]="filtersCityListSaveStepContent"
                            [joyrideStep]="'filtersCityListSaveStep'">
                <mat-label>Séléctionnez une recherche enregistrée</mat-label>
                <mat-select disableOptionCentering [(ngModel)]="currentSearch" (ngModelChange)="loadSearch($event)"
                            [disabled]="userSearchs.length == 0 || !authenticationService.isAllowed('essentiel')"
                            class="select-search" placeholder="Mes recherches">
                    <mat-option *ngFor="let s of userSearchs" [value]="s">{{s.title}}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="col-lg-2 col-3 ps-2 dropdown dropstart hide-mobile">
            <button
                *ngIf="currentSearch && params.id != 'result'"
                (click)="trackingService.click('search_city_result_search_edit', currentSearch.id)"
                class="btn btn-outline mobile-icon" id="dropdownEdit" data-bs-toggle="dropdown" aria-haspopup="true"
                aria-expanded="false">
                <i class="fa fa-ellipsis-v"></i>
                <span>Éditer</span>
            </button>
            <div id="editDropdown" class="dropdown-menu dropdown-menu-left" aria-labelledby="dropdownEdit"
                 aria-haspopup="true"
                 aria-expanded="false">
                <ul class="pictoList">
                    <li>
                        <a (click)="trackingService.click('search_city_result_search_rename', currentSearch.id);editSearch()">
                            <i class="fa cfa cfa-pencil"></i>
                            Renommer
                        </a>
                    </li>
                    <li>
                        <a (click)="trackingService.click('search_city_result_search_duplicate', currentSearch.id);duplicateSearch()">
                            <i class="fa cfa cfa-clone"></i>
                            Dupliquer
                        </a>
                    </li>
                    <li class="delete">
                        <a (click)="trackingService.click('search_city_result_search_delete', currentSearch.id);deleteSearch()">
                            <i class="fa cfa cfa-trash"></i>
                            Supprimer
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="col-lg-6 col-md-12 col-4 text-end ps-0">
            <div class="d-inline-block">
                <button class="btn btn-outline mobile-icon"
                        (click)="trackingService.click('search_city_result_search_save', currentSearch.id);saveSearch()"
                        *ngIf="this.currentSearch && params.id == 'result'"
                        (next)="saveSearch()"
                        [stepContent]="filtersCityResultSaveStepContent"
                        [joyrideStep]="'filtersCityResultSaveStep'">
                    <i class="fa cfa cfa-save"></i>
                    <span>Sauvegarder mon secteur</span>
                </button>
            </div>
            <a class="btn btn-primary ms-2 ps-sm-4 pe-sm-4 mobile-icon"
               [routerLink]="['/app/city', params.id, 'filters']"
               [stepContent]="searchCityFiltersStepContent"
               [joyrideStep]="'searchCityFiltersStep'">
                <i class="fa cfa cfa-filter"></i>
                <span>Filtrer</span>
            </a>
        </div>
    </div>
    <div class="row mt-md-3 mb-md-3 resultRow">
        <div class="col-md-6 col-12">
            <h2 *ngIf="result >= 0">
                <b class="text-primary"><span *ngIf="result == 2000">Plus de&nbsp;</span>{{ result | number }}&nbsp;</b>
                <ng-container *ngIf="result <= 1">villes trouvée</ng-container>
                <ng-container *ngIf="result > 1">villes trouvées</ng-container>
            </h2>
        </div>
    </div>
    <div class="row">
        <div class="col-12 mb-4">

        </div>
        <ng-container *ngFor="let city of cities; index as i;">
            <div class="col-12 mb-4">
                <div class="card searchResult"
                     [stepContent]="searchCityResultStepContent"
                     [joyrideStep]="'searchCityResultStep' + i">
                    <div class="card-body card-{{ city.id }}" *ngIf="city">
                        <div class="container-fluid">
                            <div class="mainRow row">

                                <div class="wrapImg me-2 mb-lg-0 mb-2"
                                     [stepContent]="searchCityResultImgStepContent"
                                     [joyrideStep]="'searchCityResulImgtStep' + i">
                                    <img src="{{ city.image }}" alt=""/>
                                </div>
                                <div class="mainInfo me-lg-2 mb-lg-0 mb-2">
                                    <b class="text-primary fs-4 mt-3 d-block" style="line-height: 1.5rem;">
                                        {{ city.zip_code }}
                                    </b>
                                    <span class="fs-7">
                                            {{ city.name }}
                                        </span>
                                    <b class="d-block mt-2 fs-6"></b>

                                    <a class="mt-3 btn btn-primary btn-sm text-white"
                                       [routerLink]="['/app/tools/ville', city.city_code]" target="_blank">
                                        Analyse de la ville
                                    </a>
                                </div>
                                <div class="kpiInfo kpiInfoVille pe-0 ps-3 col-xxl-6 col-xl-6 col-lg-5">
                                    <div class="row">
                                        <div class="col-12 dataInfo">
                                            <div class="row pt-3 pt-sm-0">
                                                <div class="kpi-value">
                                                    <label>Nombre d'habitants</label>
                                                    <p [ngClass]="{'value': true, 'text-green' : city.demographie_annuelle.Cr == 1, 'text-red' : city.demographie_annuelle.Cr == -1}">
                                                        {{ city.demographie_annuelle[EVOL_DEMO_LAST_YEAR] | number: '1.0-0' }}
                                                        <i *ngIf="city.demographie_annuelle.Cr == 1"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Démographie en hausse"
                                                           class="fa fa-arrow-up"></i>
                                                        <i *ngIf="city.demographie_annuelle.Cr == 0"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Démographie stable"
                                                           class="fa fa-arrow-right"></i>
                                                        <i *ngIf="city.demographie_annuelle.Cr == -1"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Démographie en baisse"
                                                           class="fa fa-arrow-down"></i>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>Niveau de vie moyen/hab</label>
                                                    <p class="value">
                                                        {{ city.carac_commune.MED_NV | number: '1.0-0' }} <span
                                                        class="unit">€</span>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Rendement moyen tout type de biens confondus, sans prise en compte de travaux"></i>
                                                        Rendement moyen
                                                    </label>
                                                    <p class="value">
                                                        {{ city.renta["R"] * 100| number: '1.0-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>Étudiants</label>
                                                    <p [ngClass]="{'value': true, 'text-green' : city.carac_commune.T_etud >= 0.12 , 'text-red' : city.carac_commune.T_etud <= 0.08}">
                                                        {{ city.carac_commune.T_etud * 100 | number: '1.1-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>
                                                <div class="kpi-value">
                                                    <label>Chômage</label>
                                                    <p [ngClass]="{'value': true, 'text-green' : city.carac_commune.T_chom < 0.075 , 'text-red' : city.carac_commune.T_chom >= 0.13}">
                                                        {{ city.carac_commune.T_chom * 100 | number: '1.1-1' }}
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        Tension locative
                                                    </label>
                                                    <p class="value">
                                                        {{ city.loc_service_tensiometre.all.loc == -1 ? '-' : city.loc_service_tensiometre.all.loc }}
                                                        / 8
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Pourcentage de locataires dans la ville"></i>
                                                        Taux de locataire
                                                    </label>
                                                    <p class="value">
                                                        {{ city.logement.T_LOC * 100 | number: '1.1-1' }} %
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Ancienneté des locataires dans le logement, Moyenne France : 4 ans"></i>
                                                        Ancienneté des locataires
                                                    </label>
                                                    <p [ngClass]="{'value': true, 'text-green' : city.logement.anc_loc_ann > 4.5 , 'text-red' : city.logement.anc_loc_ann < 2.5}">
                                                        {{ city.logement.anc_loc_ann | number: '1.1-1' }} années
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i *ngIf="city.evol_prix_ville.evol_5y == ''"
                                                           class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Les données de la ville ne permettent pas d'indiquer une évolution."></i>
                                                        <i *ngIf="city.evol_prix_ville.evol_5y != ''"
                                                           class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Variation des prix appartements dans la ville sur 5 an"></i>
                                                        Evolution des prix sur 5 ans
                                                    </label>
                                                    <p [ngClass]="{'value': true, 'text-green' : toFloat(city.evol_prix_ville.evol_5y) > 3 , 'text-red' : toFloat(city.evol_prix_ville.evol_5y) < -3}">
                                                        <ng-container *ngIf="city.evol_prix_ville.evol_5y == ''">
                                                            -
                                                        </ng-container>
                                                        <ng-container *ngIf="city.evol_prix_ville.evol_5y != ''">
                                                            {{  toFloat(city.evol_prix_ville.evol_5y) * 100 | number: '1.1-1' }}
                                                        </ng-container>
                                                        <span class="unit">%</span>
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        <i class="fa fa-question-circle"
                                                           matTooltipClass="tooltip-button"
                                                           matTooltip="Prix moyen pour {{ cityService.getFullLib('city.prix_commune.B', city, '') }}"></i>
                                                        Prix/m²
                                                    </label>
                                                    <p class="value">
                                                        {{ cityService.getPriceValue(city, 'city.prix_commune.B', '').pM | number: '1.0-0' }}
                                                        <span
                                                            class="unit">€</span>
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        Nombre d'entreprises
                                                    </label>
                                                    <p class="value">
                                                        {{ city.ets.ETNTOT21 | number: '1.0-0' }}
                                                    </p>
                                                </div>

                                                <div class="kpi-value">
                                                    <label>
                                                        Nombre de commerces
                                                    </label>
                                                    <p class="value">
                                                        {{ city.commerce.tot_com | number: '1.0-0' }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="card card-loading" [hidden]="!loading">
            <div class="card-body">
                <mat-spinner color="second"></mat-spinner>
            </div>
        </div>

        <ul class="pagination mb-4" *ngIf="loading == false">
            <li *ngIf="page > 1"><a class="prev" (click)="loadResult(page - 1)"><</a></li>
            <li *ngFor="let p of pages"><a (click)="loadResult(p)" [ngClass]="{'current' : p == page}">{{ p }}</a></li>
            <li *ngIf="page < pages[pages.length-1]"><a class="next" (click)="loadResult(page + 1)">></a></li>
        </ul>
    </div>
</div>

<!-- Onboarding -->
<joyrideStep [stepContent]="filtersCityStepContent"
             joyrideStep="filtersCityStep"
             stepPosition="center">
</joyrideStep>
<ng-template #filtersCityStepContent>
    <div class="fs-6 user_onboarding_author">
        <img src="assets/Thomas.png" width="40px" class="me-3  rounded-circle"/><b>Thomas</b> de LyBox<br/>
    </div>
    <img src="assets/villes_rentables.png" class="user_onboarding_visuel"/>
    <div class="p-2 user_onboarding_content">
        <h2>Comment trouver les meilleures villes pour investir ?</h2>
        <p>
            LyBox récolte des <b>milliers de données</b> sur toutes les villes de France.<br/>
            <br/>
            Dans ce module, nous allons apprendre à <b>trouver les meilleures villes pour investir</b> autour de chez
            vous.<br/>
            <br/>
            Le résultat va peut-être vous surprendre !
        </p>
    </div>
</ng-template>

<ng-template #searchCityResultStepContent>
    <div class="user_onboarding_content">
        <h2>Aperçu des villes</h2>
        <p>
            Retrouvez ici tous les <b>chiffres clés de la ville</b> comme :
        </p>
        <ul>
            <li>Le nombre d’habitants</li>
            <li>L’évolution des prix</li>
            <li>Les étudiants, le chômage …</li>
        </ul>
        <p>
            La couleur des bulles vous aide dans votre choix :
        </p>
        <ul>
            <li>En <b>vert</b> : c’est positif (Ex : faible taux de chômage ou fort taux d’étudiant)</li>
            <li>En <b>blanc</b> : c’est dans la moyenne</li>
            <li>En <b>rouge</b> : c’est négatif (moins bon que dans le reste de la France)</li>
        </ul>
    </div>
</ng-template>

<ng-template #searchCityResultImgStepContent>
    <div class="user_onboarding_content">
        <h2>Pour plus de détail</h2>
        <p>
            A tout moment, vous pouvez cliquer sur “Analyse de la ville” pour avoir accès à une <b>étude
            détaillée</b>.<br/>
            <br/>
            Tout ça c’est bien beau, mais comment on fait pour <b>choisir les meilleures villes</b> ?<br/>
            <br/>
            Suivez moi, c’est par ici 🙂<br/>
        </p>
    </div>
</ng-template>

<ng-template #searchCityFiltersStepContent>
    <div class="user_onboarding_content">
        <h2>Modifier les filtres</h2>
        <p>
            Maintenant, allons choisir ensemble les filtres pour construire votre <b>recherche de ville sur mesure</b> !
        </p>
    </div>
</ng-template>

<joyrideStep [stepContent]="filtersCityResultStepContent"
             joyrideStep="filtersCityResultStep"
             stepPosition="center">
</joyrideStep>
<ng-template #filtersCityResultStepContent>
    <div class="user_onboarding_content">
        <h2>Résultat de votre recherche</h2>
        <p>
            Voici la liste des villes correspondant à votre recherche.<br/>
            <br/>
            Votre prochaine ville préférée se trouve sûrement juste ici 😉<br/>
        </p>
    </div>
</ng-template>

<ng-template #filtersCityResultSaveStepContent>
    <div class="user_onboarding_content">
        <h2>Résultat de votre recherche</h2>
        <p>
            Cliquez ici pour enregistrer votre recherche et y revenir quand vous voulez
        </p>
    </div>
</ng-template>

<ng-template #filtersCityListSaveStepContent>
    <div class="user_onboarding_content">
        <h2>Enregistrer votre recherche</h2>
        <p>
            Vous pouvez accéder à vos recherches enregistrées depuis ce menu déroulant.<br/>
            <br/>
            Vous pourrez modifier les critères ou supprimer votre recherche<br/>
            <br/>
            <b>Astuce</b> : Maintenant que votre secteur de recherche est enregistré, vous pouvez l’utiliser dans vos
            recherches d’annonces immobilières !<br/>
            <br/>
            Pour cela, rendez vous dans le menu “Recherche” à gauche, puis “Secteur de recherche”, puis “Secteur de
            recherche avancé” 😀
        </p>
    </div>
</ng-template>
